function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import styled from 'styled-components';
import { media } from '../../breakpoints.js';
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Carousel/index.js';
import { CarouselButtons, CAROUSEL_BUTTON_SIZE } from '../../ui/Carousel/CarouselButtons.js';
import { CarouselIndicators } from '../../ui/Carousel/CarouselIndicators.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import { HighlightCardsCarouselCard, CAROUSEL_CARD_IMAGE_HEIGHTS } from './HighlightCardsCarouselCard.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Carousel } from '../../ui/Carousel/Carousel.js';
import { Div } from '../../ui/Div/Div.js';
const iconStyleMap = {
  default: 'currentColor',
  dark: 'primaryForeground',
  subtle: 'currentColor',
  wash: 'currentColor',
  darkwash: 'primaryForeground',
  primary: 'currentColor'
};
function HighlightCardsCarousel({
  autoplayInterval = '0',
  autoplayLoop = false,
  cards = [],
  hasSpacingTop,
  anchor,
  style = 'default'
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    primary = _componentsThemeMap$s.primary,
    borderLine = _componentsThemeMap$s.borderLine;
  const isAutoplay = Number(autoplayInterval) > 0;
  const autoIntervalSeconds = Number(autoplayInterval) * 1000;
  const firstCard = cards[0];
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HighlightCardsCarousel",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        hasSpacingTop: hasSpacingTop,
        hasSpacingHorizontal: false,
        background: background,
        anchor: anchor,
        children: [/*#__PURE__*/jsx(Carousel, {
          autoplay: isAutoplay,
          autoplayInterval: autoIntervalSeconds,
          autoplayLoop: autoplayLoop,
          carouselIndicators: /*#__PURE__*/jsx(SpacedCarouselIndicators, {
            color: primary,
            colorInactive: style === 'primary' ? 'foreground' : borderLine
          }),
          carouselButtons: /*#__PURE__*/jsx(SpacedCarouselButtons, {
            color: iconStyleMap[style]
          }),
          isFixedHeight: true,
          children: cards.map((card, index) => /*#__PURE__*/jsx(HighlightCardsCarouselCard, _objectSpread({
            style: style
          }, card), index))
        }), /*#__PURE__*/jsx(Div, {
          opacity: 0,
          "aria-disabled": "true",
          children: /*#__PURE__*/jsx(HighlightCardsCarouselCard, _objectSpread({
            style: style
          }, firstCard))
        })]
      })
    })
  });
}
const SpacedCarouselIndicators = styled(CarouselIndicators)`
  bottom: auto;
  top: ${CAROUSEL_CARD_IMAGE_HEIGHTS.sm + 32}px;

  ${media.md} {
    top: ${CAROUSEL_CARD_IMAGE_HEIGHTS.md + 32}px;
  }

  ${media.lg} {
    top: ${CAROUSEL_CARD_IMAGE_HEIGHTS.lg + 32}px;
  }
`;
const SpacedCarouselButtons = styled(CarouselButtons)`
  display: none;

  ${media.md} {
    display: flex;
    margin-top: ${CAROUSEL_CARD_IMAGE_HEIGHTS.md / 2 - CAROUSEL_BUTTON_SIZE / 2}px;
  }

  ${media.lg} {
    display: flex;
    margin-top: ${CAROUSEL_CARD_IMAGE_HEIGHTS.lg / 2 - CAROUSEL_BUTTON_SIZE / 2}px;
  }
`;
export { HighlightCardsCarousel, iconStyleMap };
//# sourceMappingURL=HighlightCardsCarousel.js.map
